import { iconContainer } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren } from 'react';

interface MdxIconContainerProps {
  iconPath: string;
  iconAlt?: string;
  iconWidth?: number;
  iconHeight?: number;
}

const IconContainerComponent = iconContainer.component.value as FC<
  PropsWithChildren<MdxIconContainerProps>
>;

const MdxIconContainer: FC<PropsWithChildren<MdxIconContainerProps>> = ({
  children,
  ...props
}) => {
  return <IconContainerComponent {...props}>{children}</IconContainerComponent>;
};

MdxIconContainer.displayName = 'MdxIconContainer';

export { MdxIconContainer };
